import React, { useState, useEffect, useRef } from "react";
import Items from '../items/Items';
import { tipoArticulos} from "../../data/catalogos"


const descriptionEditorOptions = { height: 100 };

const LentesOftalmicos = props => {
        return (
        <Items title="Lentes Oftalmicos" typeId={tipoArticulos.LentesOftalmicos} ></Items>
    );
}

export default LentesOftalmicos;